"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
// Ruby Estate only — a grid of rental listing cards linking to /rentals. Registered
// for every business; it only appears on a site when the landlord adds it in the
// theme editor (sectionsForLine hides it from the Ruby Till editor/AI builder).
(0, manifest_1.registerSection)({
    type: 'listings',
    label: 'Rental listings',
    icon: 'home',
    category: 'rentals',
    settingsSchema: zod_1.z.object({
        heading: zod_1.z.string().max(160).default('Available now'),
        limit: zod_1.z.number().int().min(1).max(24).default(6),
    }),
    defaults: () => ({ heading: 'Available now', limit: 6 }),
    fields: [
        { name: 'heading', label: 'Heading', control: 'text' },
        { name: 'limit', label: 'Max listings', control: 'number', min: 1, max: 24 },
    ],
});
//# sourceMappingURL=listings.js.map